module.exports = __webpack_public_path__ + "img/subject.8cbd3137.svg";